import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Time module.
 * Only static (non-parameterized) routes are listed.
 */
export const TIME_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/time/time-registration',
    labelKey: 'Time.timeRegistration',
    icon: '/assets/tablerIcons/outline/clock.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeEntry'
  },
  {
    path: '/time/my-overview',
    labelKey: 'Time.myOverview',
    icon: '/assets/tablerIcons/outline/user-circle.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeEntry'
  },
  {
    path: '/time/time-bank',
    labelKey: 'Time.timeBank',
    icon: '/assets/tablerIcons/outline/wallet.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeEntry'
  },
  {
    path: '/time/self-report',
    labelKey: 'Time.selfReport',
    icon: '/assets/tablerIcons/outline/file-report.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeEntry'
  },
  {
    path: '/time/shift-plans',
    labelKey: 'Time.shiftPlans',
    icon: '/assets/tablerIcons/outline/calendar-stats.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timePlanning'
  },
  {
    path: '/time/resource-gantt',
    labelKey: 'Time.resourceGantt',
    icon: '/assets/tablerIcons/outline/timeline.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timePlanning'
  },
  {
    path: '/time/kpi-dashboard',
    labelKey: 'Time.kpiDashboard',
    icon: '/assets/tablerIcons/outline/chart-line.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeReports'
  },
  {
    path: '/time/kai-auto-register',
    labelKey: 'Time.kaiAutoRegister',
    icon: '/assets/tablerIcons/outline/sparkles.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeKai'
  },
  {
    path: '/time/kai-chat',
    labelKey: 'Time.kaiChat',
    icon: '/assets/tablerIcons/outline/message-chatbot.svg',
    moduleId: 13,
    groupLabelKey: 'MenuRoutes.group.timeKai'
  }
];
